<template>
  <div>


    <b-col cols="12" sm="12">
      <section>
        <b-row>
          <b-col cols="12">
            <b-tabs v-model="indexTab" fill>

              <!--TAB Dispositivos-->
              <b-tab :title="$t('Dispositivos')">
                <b-card>
                  <div class="text-center dispositivoNombre">
                    {{ $t("Gral.dispositivo") }}: {{ selectedDevice ? selectedDevice.nombre : $t("Gral.sinSeleccionar")
                    }}
                  </div>
                  <b-row>
                    <div class="col-xs-6 col-md-5 col-lg-5">
                      <label htmlFor="">{{ $t("Gral.dispositivo") }} </label>
                      <multiselect v-model="selectedDevice" :disabled="!hasDevices" :searchable="true"
                        :options="devices" :multiple="false" :selectLabel="$t('vHistorico.presioneAgregar')"
                        :selectedLabel="$t('vHistorico.seleccionado')"
                        :deselectLabel="$t('vHistorico.presioneEliminar')" :placeholder="$t('vHistorico.selecDispo')"
                        track-by="nombre" label="nombre">
                        <span slot="noResult">{{ $t("vHistorico.msgBusquedaFallida") }}</span>
                      </multiselect>
                    </div>
                    <div class="col-xs-6 col-md-4 col-lg-5 rango-fechas separacion-sm">
                      <label htmlFor="rangoFechas">{{ $t("Gral.rangoFechas") }}</label>
                      <flat-pickr id="rangoFechas" v-model="dateRange" :config="setConfigFlatPickr"
                        :disabled="!hasPositionsDevice" :placeholder="$t('Gral.seleccionarFecha')" />
                    </div>
                    <div class="col-xs-6 col-md-3 col-lg-2 d-flex align-items-end consultar separacion-sm">
                      <b-btn class="d-flex align-items-center justify-content-center text-white w-100" variant="info"
                        :disabled="!dateRange" @click="searchHistoryByDevice">
                        <feather type="search" class="feather-sm mr-2"></feather>
                        {{ $t("vBitacora.consultar") }}
                      </b-btn>
                    </div>
                  </b-row>
                  <b-alert v-if="lblTotalPositions !== ''" class="mt-3 mb-0 alertTotalPosiciones" show
                    variant="secondary">
                    {{ lblTotalPositions }}
                  </b-alert>
                </b-card>
              </b-tab>

              <!--TAB Areas-->
              <b-tab :title="$t('vMonitoreo.areas')">
                <b-card>
                  <span style="font-size: 15px; font-weight: 400;">* {{ $t('Gral.camposObligatorios') }}</span>
                  <b-row class="mt-2">
                    <b-col lg="2" md="4" sm="6">
                      <label htmlFor="rangoFechasAreas">{{ $t("Gral.rangoFechas") }}:*</label>
                      <flat-pickr id="rangoFechasAreas" v-model="dateRange" :config="setConfigFlatPickr"
                        :placeholder="$t('Gral.seleccionarFecha')" />
                    </b-col>
                    <b-col lg="2" md="4" sm="6">
                      <b-form-group :label="$t('Gral.medida') + ':'">
                        <b-form-select id="distancia" v-model="datosRadio.distancia" :options="translateMedida">
                          <template #first>
                            <b-form-select-option :value="null" disabled>
                              {{ $t("vGeocercas.selectMedida") }}
                            </b-form-select-option>
                          </template>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="2" md="4" sm="6" class="mt-radio">
                      <label for="“radio”">{{ this.$t("Gral.radio") }}: *</label>
                      <b-form-input type="number" step="0.001" min="1" max="1000" id="radioV"
                        v-model="datosRadio.radio">
                      </b-form-input>
                    </b-col>
                    <b-col lg="2" md="4" sm="6">
                      <label for="“latitud”">{{ this.$t("Gral.latitud") }}: * </label>
                      <b-form-input id="latitud" type="number" step="0.00000001" max="90" min="-90"
                        v-model="geocerca.latitud">
                      </b-form-input>
                    </b-col>
                    <b-col lg="2" md="4" sm="6">
                      <label for="“longitud”">{{ this.$t("Gral.longitud") }}: *</label>
                      <b-form-input id="longitud" type="number" step="0.00000001" max="180" min="-180"
                        v-model="geocerca.longitud">
                      </b-form-input>
                    </b-col>
                    <b-col lg="2" md="4" sm="6" class="mt-button">
                      <b-btn class="text-white d-flex align-items-center justify-content-center w-100 sm-button"
                        style="margin-top: 32.5px" variant="info" text type="submit" color="blue"
                        :disabled="isAllFieldsRequired" @click="searchAreas()">
                        <feather type="search" class="feather-sm mr-2">
                        </feather>
                        {{ $t("vBitacora.consultar") }}
                      </b-btn>
                    </b-col>
                  </b-row>
                </b-card>
              </b-tab>
            </b-tabs>
            <!--Mapa-->
            <div class="map-wrapper-scaling">
              <mapa class="mt-3" ref="map" :options="mapOptions" @mapReference="mapReference = $event"
                @geoData="getlatlngGeofence">
                <video-player v-if="playerActive" :map="mapReference" :positions="positionsDevice"
                  :statics="staticsPositions" @leafletControl="lControl = $event" @leafletMarkers="lMarkers = $event">
                </video-player>
              </mapa>
            </div>
            <section v-if="loadMapComponents">
              <div style="width: 100%; display: flex; flex-wrap: wrap; justify-content: space-evenly;margin-top: 24px;">
                <div>
                  <b-btn class="mt-1" variant="info" @click="descargarExcel('excel')" style="color: white"
                    :disabled="banderaDescargarHistorial">
                    <feather type="download" class="feather-sm mr-2"></feather>{{ $t('vHistorico.descargarExcel') }}
                  </b-btn>
                </div>

                <div>
                  <b-btn class="mt-1" variant="info" @click="descargarExcel('csv')" style="color: white"
                    :disabled="banderaDescargarHistorial">
                    <feather type="download" class="feather-sm mr-2"></feather>{{ $t('vHistorico.descargarCSV') }}
                  </b-btn>
                </div>
              </div>


            </section>





          </b-col>
        </b-row>
      </section>
    </b-col>

    <ProgressBarContador ref="progress" :active="mostrarBarra" />
  </div>
</template>


<script>
import Multiselect from "vue-multiselect";
import DevicesDataService from "../../../services/DevicesDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import PosicionesDataService from "../../../services/PosicionesDataService";

import Crypto from '../../../services/Crypto';
import Mapa from '../../components/Map';
import { customizedAlert, generalSweetAlert } from "../../../utils/Utils";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import flatPickr from "vue-flatpickr-component";
import VideoPlayer from '../../components/VideoPlayer.vue';
import { getTypeIcon } from "../../components/MapFunctions";
import ProgressBarContador from "../../components/ProgressBar.vue";


export default {
  name: "historico",
  components: {
    Multiselect,
    flatPickr,
    Mapa,
    VideoPlayer,
    ProgressBarContador,
  },
  data() {
    return {
      registrosProcesados: 0,
      nTotalRegistros: 0,
      mostrarBarra: false,

      indexTab: 0,
      selectedDevice: null,
      hasDevices: false,
      devices: [],
      key: null,
      dateRange: null,
      hasPositionsDevice: false,
      date: { start: null, end: null },
      positionsDevice: [],
      staticsPositions: [],
      lblTotalPositions: '',
      playerActive: false,
      lControl: null,
      lMarkers: null,
      dispos: [],


      geocerca: {
        id: 0,
        latitud: 0,
        longitud: 0,
        radio: 0,
        tipo: '',
        color: "#000000",
        locate: null,
        usuario: null,
      },



      setConfigFlatPickr: {
        wrap: true,
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "Y-m-d",
        minDate: new Date().fp_incr(-30),
        maxDate: new Date(),
        mode: "range",
        locale: Spanish,
      },
      datosRadio: {
        radio: "",
        distancia: null,
      },
      distancia: [
        { text: "metros", value: "Metros." },
        { text: "km", value: "Kilómetros." },
      ],
      mapOptions: {
        useLocateControl: true,
        useControlLegend: true,
        useDrawTools: false,
        useRuleTool: true,
        imgUrl: this.$t('Gral.imgLeyenda'),
      },
      mapReference: null,

      marcadores: [],

      loadMapComponents: true,

      /**
       * Bandera para habilitar o deshabilitar botones de descarga del historial
       */
      banderaDescargarHistorial: true,
    }
  },
  watch: {
    indexTab(newIndex) {

      this.clearWorkspace();
      this.mapOptions.useDrawTools = !this.mapOptions.useDrawTools;
      console.log("Tab changed to: ", newIndex === 0 ? "Dispositivos" : "Áreas");
    },
    selectedDevice(newDevice) {
      this.dateRange = null;
      this.lblTotalPositions = '';
      if (newDevice) {
        this.hasLocationHistory(newDevice)
      } else {
        this.hasPositionsDevice = false;
      }
    },
    dateRange(newDateRange) {
      if (newDateRange) {
        this.parseDateRange(newDateRange)
      } else {
        this.date = { start: null, end: null }
      }
    },

  },
  computed: {
    translateMedida() {
      return this.translateOptions(this.distancia)
    },
    isAllFieldsRequired() {
      return this.dateRange === null;
    },

    progress() {
      if (this.nTotalRegistros == 0) return 0;
      return (Number.parseInt(this.registrosProcesados) / Number.parseInt(this.nTotalRegistros)) * 100;
    }
  },
  mounted() {
    this.key = sessionStorage.getItem('key');
    this.getDevices();
    this.$nextTick(() => {
      this.$refs.map.locateControl.start();
    });

  },
  methods: {
    async searchAreas() {
      try {
        console.log("entro");

        if (this.geocerca.tipo === "Point") {
          const distance = this.datosRadio.distancia;

          let radio = this.datosRadio.radio;
          if (distance != "Metros.") {
            radio = radio * 1000;
          }

          const data = {
            fechaInicial: this.date.start,
            fechaFinal: this.date.end,
            latitud: this.geocerca.latitud,
            longitud: this.geocerca.longitud,
            radio: radio,
          }
          console.log("data 1: ", data);


          try {
            const response = await PosicionesDataService.getDispositivosPorArea(data, this.key);
            this.dispos = await Crypto.desencriptar(response.data, this.key);
            console.log("response getDispositivosPorArea", response);


            const layer = this.geocerca.layer;
            if (this.dispos.length) {

              generalSweetAlert("Se han encontrado " + this.dispos.length + " dispositivos dentro del área marcada", "success");
              this.dispos.forEach(dispositivo => {
                const data = {
                  icon: getTypeIcon('OFF'),
                  latlng: { lat: dispositivo.latitud, lng: dispositivo.longitud },
                  popup: this.getPopup(dispositivo),
                }
                this.$refs.map.renderEntityOnMap(data).bindPopup(data.popup);
              });
              layer.setStyle({
                color: "#e32626",
              });
            } else {
              generalSweetAlert(this.$t("Gral.busquedaFallida"), "error");
              const layer = this.geocerca.layer;
              layer.setStyle({
                color: "#68e557",
              });
            }
          } catch (error) {
            console.error("Error de servicio al consultar las últimas posiciones", error);
          }
        } else if (this.geocerca.tipo === "Polygon") {
          const coordinates = this.geocerca.coordinates;

          const data = {
            fechaInicial: this.date.start,
            fechaFinal: this.date.end,
            coordenadas: coordinates.toString()
          }

          try {
            const response = await PosicionesDataService.getDispositivosPorAreaPoligonal(data, this.key);
            this.dispos = await Crypto.desencriptar(response.data, this.key);

            const layer = this.geocerca.layer;

            if (this.dispos.length) {
              generalSweetAlert("Se han encontrado " + this.dispos.length + " dispositivos dentro del área marcada", "success");
              this.dispos.forEach(dispositivo => {
                const data = {
                  icon: getTypeIcon('OFF'),
                  latlng: { lat: dispositivo.latitud, lng: dispositivo.longitud },
                  popup: this.getPopup(dispositivo),
                }
                this.$refs.map.renderEntityOnMap(data).bindPopup(data.popup)
              });
              layer.setStyle({
                color: "#e32626",
              });
            } else {
              generalSweetAlert(this.$t("Gral.busquedaFallida"), "error");
              const layer = this.geocerca.layer;
              layer.setStyle({
                color: "#68e557",
              });
            }
          } catch (error) {
            console.error("Error de servicio al consultar las últimas posiciones", error);
          }
        }
      } catch (err) {
        console.error("Error crítico en searchAreas:", err);
        // Opcional: una alerta general para errores de lógica o variables no definidas
        // generalSweetAlert("Ocurrió un error inesperado en la búsqueda", "error");
      }
    },

    getPopup(datos) {
      return `
        <b>${datos.dispositivo.nombre}</b><br>
        <b>${this.$t("Gral.latitud")}: </b>${datos.latitud}<br>
        <b>${this.$t("Gral.longitud")}: </b>${datos.longitud}<br>
        <b>${this.$t("Gral.tipo")}: </b>${datos.tipo}<br>
        <b>${this.$t("vMonitoreo.velocidad")}: </b>${datos.velocidad} Km/h<br>
        <b>${this.$t("vMonitoreo.estadia")}: </b>${this.formatoEstadia(datos.tiempoEstatico)}<br>
        <b>${this.$t("vMonitoreo.actualizacion")}: </b>${datos.description} hrs.<br>
        <b>${this.$t("vMonitoreo.sinActividad")}: </b>${this.formatoEstadia(datos.tiempoOffline)}<br>
      `;
    },
    formatoEstadia(segundos) {
      let segs,
        dias,
        horas,
        min,
        cad = "No aplica";

      segs = segundos;
      if (segs == null || segs <= 60) {
        // si el tiempo de estadía es menor a un minuto o null, No aplica
        return cad;
      } else {
        cad = "";
      }
      if (segs > 86400) {
        //Días
        dias = Math.floor(segs / 86400);
        segs -= dias * 86400;
        cad += dias + " días ";
      }
      if (segs > 3600) {
        //Horas
        horas = Math.floor(segs / 3600);
        segs -= horas * 3600;
        cad += horas + " horas ";
      }
      if (segs > 60) {
        //Minutos
        min = Math.floor(segs / 60);
        segs -= min * 60;
        cad += min + " minutos ";
      }
      if (segs > 0) {
        //Segundos
        cad += segs + " segundos.";
      }
      return cad;
    },
    getlatlngGeofence(latlng) {
      try {

        if (latlng.type === 'Point') {
          this.geocerca.latitud = latlng.coordinates[1];
          this.geocerca.longitud = latlng.coordinates[0];
          this.datosRadio.radio = latlng.radiusConfig.radius;
          const unit = latlng.radiusConfig.unit;
          if (unit === 'meters') this.datosRadio.distancia = "Metros.";
          else if (unit === 'km') this.datosRadio.distancia = "Kilómetros.";
        } else {
          this.geocerca.coordinates = latlng.coordinates;
          this.figura = false;
        }
        this.geocerca.tipo = latlng.type;
        this.geocerca.layer = latlng.layer
      } catch (e) {
        console.error("Error en la funcion getlatlngGeofence: ", e)
      }

    },
    /** Método encargado de obtener los dispositivos GPS. */
    async getDevices() {
      try {
        const response = await DevicesDataService.getAllOrden();
        const devicesFetch = await Crypto.desencriptar(response.data, this.key);
        this.hasDevices = devicesFetch.length > 0;
       
          
        if (this.hasDevices) {
          this.devices = this.filterDevicesByCurrentUser(devicesFetch)
        } else {
          customizedAlert(this.$t("vMonitoreo.msgSinDispositivos"), this.$t("vHistorico.msgModalNoDispo"), "warning", "gray");
        }
      } catch (error) {
        console.error("Error de servicio al consultar los dispositivos", error);
      }
    },
    /**
    * Método encargado de filtrar los dispositivos obtenidos.
    * Este filtro se realiza ya que un usuario máster puede estar observando
    * el espacio de trabajo de algún otro usuario.
    */
    filterDevicesByCurrentUser(devices) {
      if (sessionStorage.getItem('idRol') === process.env.VUE_APP_ID_MASTER) {
        const userFiltered = sessionStorage.getItem("usuarioFiltro");
        if (userFiltered) {
          const user = JSON.parse(userFiltered);
          if (user.rol.id == process.env.VUE_APP_ID_ADMINISTRADOR) {
            return devices.filter(device => device.area && device.area.id === user.area.id);
          } else {
            return devices.filter(device =>
              device.usuarios && device.usuarios.some(usuario => usuario.id === user.id)
            );
          }
        }
      }
      return devices;
    },

    async hasLocationHistory(device) {
      try {


        const response = await PosicionesDataService.getPositionByDevice(device.id, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key)
        this.hasPositionsDevice = decoded;
        if (!this.hasPositionsDevice) {
          generalSweetAlert(this.$t("vHistorico.msgNoPosiciones"), 'info');
        }
      } catch (error) {
        console.error("Error de servicio al obtener la última posición del dispositivo", error);
      }
    },

    parseDateRange(dateRange) {
      const provisionalDate = dateRange.split(" ");
      this.date.start = provisionalDate[0];
      if (provisionalDate.length > 2) {
        this.date.end = provisionalDate[2];
      } else {
        this.date.end = this.date.start;
      }
    },

    async searchHistoryByDevice() {
      try {
        this.nTotalRegistros = 0;

        this.playerActive = false;
        this.lblTotalPositions = '';
        this.banderaDescargarHistorial = true;
        await this.clearMapContent();

        this.mostrarBarra = true;


        const data = {
          matricula: sessionStorage.getItem('username'),
          imei: this.selectedDevice.imei,
          fechaInicial: this.date.start,
          fechaFinal: this.date.end
        }
        const resp = await this.getPositionsHistory(data);

        if (resp) {
          this.getStaticPositions(data);
          this.banderaDescargarHistorial = false;
        }
      } catch (error) {
        console.error("Error de servicio al consultar posiciones del historial", error);
      } finally {
        this.mostrarBarra = false;
      }

    },

    async getPositionsHistory(data) {
      try {
        const response = await PosicionesDataService.getHistory(data, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key);
        this.positionsDevice = decoded;


        this.lblTotalPositions = this.$t("vHistorico.lblResultados", { 0: decoded.properties.length });


        this.playerActive = true;
        return true;
      } catch (error) {
        console.error("Error de servicio al consultar el histórico de posiciones", error);
        generalSweetAlert(this.$t("vHistorico.msgSinPos"), 'error');
        return false;
      }
    },

    async getStaticPositions(data) {

      try {
        const response = await PosicionesDataService.getStaticHistory(data, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key);


        this.staticsPositions = await decoded.map(this.getDisplayPosicion);
        console.log("this.staticsPositions:: ", this.staticsPositions);

      } catch (error) {
        console.error("Error de servicio al consultar posiciones estáticas", error);
        generalSweetAlert(this.$t("vHistorico.msgSinPos"), 'error');
      }
    },


    async logAction(action) {
      const data = {
        usuario: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
        accion: action + sessionStorage.getItem('infoDevice'),
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      await AccionesDataService.create(data, this.key);
    },



    getDisplayPosicion(posicion) {
      const optionsFecha = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };

      // Normaliza valores por defecto
      const dispositivo = posicion.dispositivo || {};
      const tipo = posicion.tipo === "LAC" ? "LBS" : (posicion.tipo || "GPS");
      const estado = posicion.estatusMovimiento || "OFF";

      return {
        id: posicion.id,
        name: dispositivo.nombre || "Sin nombre",
        dispositivo: dispositivo.id || null,
        distancia: posicion.precision || 0,
        description: new Date(posicion.fechaHoraPosicion).toLocaleDateString("es-ES", optionsFecha),
        date_build: "", // ¿Este valor se llena después?
        imei: dispositivo.imei || "Sin imei",
        position: {
          lat: Number(posicion.latitud).toFixed(8),
          lng: Number(posicion.longitud).toFixed(8),
        },
        usuario: "Desconocido", // ¿Este valor puede venir del backend?
        velocidad: Number(posicion.velocidad || 0).toFixed(2),
        knots: Number(posicion.knots || 0).toFixed(2),
        estado,
        marker: null,
        tiempoEstatico: posicion.tiempoEstatico || 0,
        tiempoOffline: posicion.tiempoOffline || 0,
        tipo,
      };
    },


    clearWorkspace() {
      this.resetVariables();
      this.clearMapContent();
    },

    async resetVariables() {

      if (this.indexTab === 0) {
        console.log('Limpiar las variables utilizaddas en el tab de Areas');
        this.dateRange = null;
        this.datosRadio.distancia = null;
        this.datosRadio.radio = null;
        this.geocerca.latitud = 0;
        this.geocerca.longitud = 0;
        this.$refs.map.clearEntities();
        this.date = { start: null, end: null };
        this.banderaDescargarHistorial = true;

      } else {
        console.log('Limpiar las variables utilizadas en el tab de Dispositivos');
        this.selectedDevice = null;
        this.dateRange = null;
        this.lblTotalPositions = '';
        this.$refs.map.removeEntityFromMap(this.staticsPositions, true);
        this.playerActive = false;
        this.date = { start: null, end: null };
        this.banderaDescargarHistorial = true;
      }
    },

    async clearMapContent() {
      if (this.lMarkers) {
        this.lMarkers.forEach(marcador => {
          this.mapReference.removeLayer(marcador);
        });
      }
      if (this.lControl) {
        this.mapReference.removeControl(this.lControl);
      }
    },

    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`vGeocercas.${option.text}`),
          };
        }
      });
    },

    descargarExcel(excel) {
      const aFechaSelect = this.dateRange.split(" ");

      const data = {
        imei: this.selectedDevice.imei,
        username: sessionStorage.getItem("username"),
        fechaInicial: aFechaSelect[0],
        fechaFinal: aFechaSelect.length > 1 ? aFechaSelect[2] : aFechaSelect[0],
        formato: excel
      }

      if (excel === "excel") {
        this.extensionArchivo = `.xlsx`;
        this.accion = "Descargó historial en excel del dispositivo " + this.selectedDevice.nombre + " con fecha " + this.dateRange;
        this.registrarAccion();
      } else {
        this.extensionArchivo = `.csv`;
        this.accion = "Descargó historial en csv del dispositivo " + this.selectedDevice.nombre + " con fecha " + this.dateRange
        this.registrarAccion();
      }
      let datos = {
        posiciones: [],
        format: this.extensionArchivo,
        dispositivo: this.selectedDevice.nombre,
      };
      localStorage.setItem("excel", excel);
      datos.posiciones = this.posiciones;
      this.busy = true;
      this.obtenerHistorialExcel(data);
    },


    async obtenerHistorialExcel(data) {
      this.busy = true;
      this.cargandoArchivo = true;

      try {
        this.mostrarBarra = true;

        const response = await PosicionesDataService.getHistoryExcel(data, this.key);
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const filename = this.generarNombreArchivo();

        this.descargarBlob(blob, filename);

      } catch (e) {
        console.error("Error al descargar el archivo:", e);

        if (e?.response?.status === 401 || e.toString().includes("401")) {
          this.$router.push({ path: "/" });
          await this.$swal.fire({
            icon: "warning",
            title: this.$t("Gral.msgSesion"),
            customClass: {
              container: 'swal-custom-zindex'
            }
          });
        } else {
          await this.$swal.fire({
            icon: "error",
            title: this.$t("vHistorico.msgErrorExportar"),
            customClass: {
              container: 'swal-custom-zindex'
            }
          });
        }
      } finally {
        this.busy = false;
        this.cargandoArchivo = false;
        this.mostrarBarra = false;
      }
    },

    generarNombreArchivo() {
      const now = new Date();

      const date = now.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      }).replace("/", "");

      const time = now.toLocaleTimeString("es-ES", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).replaceAll(':', "");

      const ext = this.extensionArchivo || ".xlsx";
      const nombre = this.selectedDevice?.nombre || "dispositivo";

      return `posiciones_${nombre}_${date}_${time}${ext}`;
    },

    descargarBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },


    registrarAccion() {
      let data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + localStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "accion",
      };
      AccionesDataService.create(data, this.key);
    },

    async getTotalPosicionesPorRangoFechas(device) {
      try {

        const data = {
          id: device,
          fechaInicial: this.date.start,
          fechaFinal: this.date.end
        }

        const response = await PosicionesDataService.getTotalPosicionesPorRangoFechas(data, this.key);
        const decoded = await Crypto.desencriptar(response.data, this.key)
        this.nTotalRegistros = Number(decoded);

      } catch (error) {
        console.error("Error de servicio al obtener las posiciones del dispositivo", error);
      }
    },


  },//FIN Methods
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.dispositivoNombre {
  font-weight: 400;
  font-size: 1.8rem;
}

/* Contenedor del mapa para que sea dinámico */
.map-wrapper-scaling {
  width: 100%;
  height: 65vh;
  /* Ocupa el 65% del alto de la pantalla */
  min-height: 500px;
  margin-top: 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ddd;
}

@media (max-width: 575px) {
  .mt-button {
    margin-top: -25px;
  }

  .mt-radio {
    margin-top: -15px;
  }
}

.swal-custom-zindex {
  z-index: 11000 !important;
}
</style>
